import { Col, Form, Row, Select, Input, DatePicker } from "antd";
import { useEffect, useState } from "react";
import {
  GET_BUYER_ENDPOINT,
  GET_BUYING_OFFICE_ENDPOINT,
  SALES_CONTRACT_LIST,
  STYLE_MERCHANDISING_LIST,
  GET_SUPPLIER_ENDPOINT,
  ALL_SALES_CONTRACT_LIST,
  IMPORT_DETAIL_ALL_SUPPLIERS,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import CustomDatePicker from "common/CustomDatePicker";
const ImportB2blcFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [salseCotractList, setSalseCotractList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);

  useEffect(() => {
    getSalseCotractList();
    getSupplierList();
  }, []);

  const getSalseCotractList = async () => {
    let res = await getData(ALL_SALES_CONTRACT_LIST);

    if (res) {
      setSalseCotractList(res?.data?.data || []);
    }
  };

  const getSupplierList = async () => {
    let res = await getData(IMPORT_DETAIL_ALL_SUPPLIERS);

    if (res) {
      setSupplierList(res?.data?.data || []);
    }
  };
  return (
    <>
      <Col span={3}>
        <Form.Item label="B2B LC Number" name="b2b_lc_number">
          <Input placeholder="Write B2B LC Number" size="small" />
        </Form.Item>
      </Col>
      {/* <Col span={3}>
        <Form.Item label="B2B LC Date" name="b2b_lc_date">
          <CustomDatePicker placeholder="Write B2B LC Date" style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col> */}
      <Col span={3}>
        <Form.Item label="Sales Contract No" name="sales_contract_id">
          <Select
            showSearch
            placeholder="Select a Sales Contract No"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            size="small"
            allowClear
            onClear={() => getSalseCotractList()}
          >
            {salseCotractList?.length &&
              salseCotractList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.reference_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="Suppliers" name="supplier_id">
          <Select
            showSearch
            placeholder="Select a Supplier"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            size="small"
            allowClear
            onClear={() => getSupplierList()}
          >
            {supplierList?.length &&
              supplierList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="From Date" name="from_date" rules={[{ required: false, message: "From Date is required" }]}>
          <CustomDatePicker placeholder="From Date" size="small" />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="To Date" name="to_date" rules={[{ required: false, message: "From Date is required" }]}>
          <CustomDatePicker placeholder="To Date" size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default ImportB2blcFilterFields;
